export const Types = {
  GET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_POOL_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_POOL_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    " GET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_MAINTATENANCE_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    " GET_AUTONOMOUS_MAINTATENANCE_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_CHECK_ITEMS_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_CHECK_ITEMS_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_EQ_MAIN_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "GET_EQ_MAIN_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  GET_EXCEL_FILE: "GET_EXCEL_FIL_AUTONOMOUS_ORDER_TASKS",

  //    SET Actions
  SET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    " SET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_POOL_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    " SET_POOL_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_MAINTATENANCE_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_AUTONOMOUS_MAINTATENANCE_LIST",
  SET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS",
  SET_CHECK_ITEMS_FOR_AUTONOMOUS_ORDER_TASKS:
    "SET_CHECK_ITEMS_FOR_AUTONOMOUS_ORDER_TASKS",
  SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",

  // RESET

  RESET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_MAINTATENANCE_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_AUTONOMOUS_MAINTATENANCE_LIST",
  RESET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_CHECK_ITEMS_FOR_AUTONOMOUS_ORDER_TASKS:
    "RESET_CHECK_ITEMS_FOR_AUTONOMOUS_ORDER_TASKS",
  RESET_FILTER: "RESET_FILTER",
};

export const getTaskList = (payload) => ({
  type: Types.GET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const getList = () => ({
  type: Types.GET_POOL_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const getStatusList = () => ({
  type: Types.GET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const getSubListById = () => ({
  type: Types.GET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const showSnackMessage = (payload) => ({
  type: Types.SHOW_SNACK_MESSAGE,
  payload,
});

export const getautonomousMaintenance = (payload) => ({
  type: Types.GET_MAINTATENANCE_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const getTechnicianList = (payload) => ({
  type: Types.GET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const getCostCenterList = (payload) => ({
  type: Types.GET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const getAreaListAutonomous = () => ({
  type: Types.GET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const getMainListByAreaIDAutonomous = (payload) => ({
  type: Types.GET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const getSubListByIdAutonomous = (payload) => ({
  type: Types.GET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const downloadExcelFile = (payload) => ({
  type: Types.GET_EXCEL_FILE,
  payload,
});

// Set Actions

export const setList = (payload) => ({
  type: Types.SET_POOL_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setCheckItemsList = (payload) => ({
  type: Types.SET_CHECK_ITEMS_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setTaskList = (payload) => ({
  type: Types.SET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setStatusList = (payload) => ({
  type: Types.SET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setautonomousMaintenance = (payload) => ({
  type: Types.SET_MAINTATENANCE_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setTechnicianList = (payload) => ({
  type: Types.SET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setCostCenterList = (payload) => ({
  type: Types.SET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setAreaListAutonomous = (payload) => ({
  type: Types.SET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setMainListByAreaIDAutonomous = (payload) => ({
  type: Types.SET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

export const setSubListByIdAutonomous = (payload) => ({
  type: Types.SET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
  payload,
});

// reset Actions
//
export const resetTaskList = () => ({
  type: Types.RESET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const resetStatusList = () => ({
  type: Types.RESET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const resetCostCenterList = () => ({
  type: Types.RESET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const resetAreaListAutonomous = () => ({
  type: Types.RESET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const resetTechnicianList = () => ({
  type: Types.RESET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const resetMainListByAreaIDAutonomous = () => ({
  type: Types.RESET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const resetSubListByIdAutonomous = () => ({
  type: Types.RESET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
});

export const resetFilter = () => ({
  type: Types.RESET_FILTER,
});
